<template>
  <hypto-popup :title="'Connected Bank Balance'" :footer="false">
    <template v-slot:body>
      <p>Bank balance fetched successfully</p>
      <h6>{{amountFormat(getterConnectedBankBalance)}}</h6>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import { amountFormat } from '@/utils/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'ConnectedBankBalance',
  components: { HyptoPopup },
  computed: {
    ...mapGetters(['getterConnectedBankBalance'])
  },
  methods: {
    amountFormat
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/themes/main.scss';

  p {
    font-size: 15px;
  }
  h6 {
    font-size: 25px;
    margin-top: 10px;
    color: $primary;
  }
</style>
